import { appbarHeight, appbarHeightMobile } from "themes/constants/sizes"
import { hoverNone } from "themes/default/breakpoints"

export const styles = {
  fullContainer:
    ({ isEmbed }) =>
    (theme) => ({
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      position: "fixed",
      top: { xs: `${appbarHeightMobile}px`, sm: `${appbarHeight}px` },
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1000,
      color: theme.palette.common.white,
      boxSizing: "border-box",
      px: 4,
      ...(isEmbed && {
        top: 0,
      }),
    }),
  content: { textAlign: "center", maxWidth: "600px" },
  gameIcon: {
    fontSize: 80,
    mb: 1,
  },
  gameTitle: (theme) => ({
    color: theme.palette.common.white,
    fontSize: { xs: "2.5rem", md: "4rem" },
  }),
  readyText: (theme) => ({
    color: theme.palette.common.white,
    fontWeight: 500,
    fontSize: { xs: "1.1rem", md: "1.35rem" },
    mb: 3,
  }),
  startButton: (theme) => ({
    color: theme.palette.common.white,
    border: `2px solid ${theme.palette.background.default}`,
    borderRadius: "50px",
    px: 7,
    py: 2,
    fontSize: { xs: "1.1rem", md: "1.3rem" },
    fontWeight: 800,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    [hoverNone]: {
      "&:hover": {
        border: `2px solid ${theme.palette.background.default}`,
        backgroundColor: theme.palette.background.default,
      },
    },
  }),
  countdownContent: (theme) => ({
    width: 300,
    height: 300,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.palette.background.default,
    borderRadius: "50%",
    position: "relative",
  }),
  goText: (theme) => ({
    fontSize: 80,
    fontWeight: 900,
    color: theme.palette.primary.main,
    animation: "go-pop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards",
    "@keyframes go-pop": {
      "0%": { transform: "scale(0) rotate(-10deg)", opacity: 0 },
      "50%": { transform: "scale(1.28) rotate(5deg)" },
      "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 },
    },
  }),
}
